<!-- eslint-disable -->
<template lang="pug">
    tr.points__tr--border
        td.points__td(v-if="user.type !== 'student'")
            router-link.points__link.points__link(
                :to="{\
                    name: 'user:profile',\
                    params: {\
                        id: record.user.id,\
                        type: record.user.type\
                    }\
                }"
            )
                | {{ record.user.fullName }}

        td.points__td {{ record.createdAt | moment('DD.MM.YYYY') }}
        td.points__td(:class="points > 0 ? 'points__positive' : 'points__negative'") {{ +points }}
        td.points__td
            span(v-if="!record.source && record.sourceType === 'homework'")
                | {{ $i18n.t('historyTable.historyTable_preview_homeworkDeleted') }}
            template(v-else-if="isModel(record, 'User')")
                router-link.points__link(
                    v-if="user.type !== 'student'"
                    :to="{\
                        name: 'user:profile',\
                        params: {\
                            id: record.source.id,\
                            type: record.source.type\
                        }\
                    }"
                )
                    | {{ record.source.fullName }}
                span(v-else="") {{ record.source.fullName }}
            template(v-else-if="record.sourceType === 'homework'")
                router-link.points__link(
                    v-if="user.type !== 'student'"
                    :to="{\
                        name: 'homework:edit',\
                        params: {\
                            id: record.source.id,\
                            type: 'homework'\
                        }\
                    }"
                )
                    | {{ $i18n.t('miles.miles_historyTable_homeworkDate') }}
                    | {{ record.source.date | moment('DD.MM.YYYY') }}
                span(v-else="")
                    | {{ $i18n.t('miles.miles_historyTable_homeworkDate') }}
                    | {{ record.source.date | moment('DD.MM.YYYY') }}
            router-link.points__link(
                v-else-if="isModel(record, 'City')"
                :to="{\
                    name: 'map',\
                    params: {\
                        modal: true,\
                        location: record.source.name\
                    }\
                }"
            )
                | {{ $i18n.t('historyTable.historyTable_preview_travel') }}
                | {{ $i18n.t('mapModal.locationsWithPretext')[record.source.name] }}
            span(v-else-if="isModel(record, 'Motivation')")
                | {{ $i18n.t('historyTable.historyTable_preview_detective')}}
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex';

    export default {
        props: {
            record: Object
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            points () {
                return this.record.points > 0 ? `+${this.record.points}` : this.record.points;
            }
        },
        methods: {
            isModel(record, type) {
                return record.sourceType === 'App\\Models\\' + type;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .points__td {
        padding: 13px 12px;
        @include media($md) {
            padding: 10px 30px;
        }
    }

    .points__tr--border {
        border-bottom: 1px solid #E6E6F8;
    }

    .points__link {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .points__positive {
        color: $hsl-color-green-58;
    }

    .points__warning {
        color: $hsl-color-yellow-66;
    }

    .points__negative {
        color: $hsl-color-red-62;
    }
</style>
